// extracted by mini-css-extract-plugin
export default {"container":"LoanApplications_container__JUlda","header":"LoanApplications_header__t5fgD","title":"LoanApplications_title__sAIuB","button":"LoanApplications_button__-yhOy"};